module.exports = __webpack_public_path__ + "static/img/banner_f007.fb57265.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner_f007.jpg
// module id = TcqK
// module chunks = 40